import { useEffect } from "react";
import { loadAngularWC } from "./loadAngular";

import type { DetailedHTMLProps, HTMLAttributes } from "react";

declare module "react/jsx-runtime" {
  namespace JSX {
    interface IntrinsicElements {
      "usermgmt-app": DetailedHTMLProps<
        HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
}

interface AngularHostProps {
  hidden?: boolean;
}

export default function AngularHost({ hidden = false }: AngularHostProps) {

  useEffect(() => {
    loadAngularWC();

    // Only navigate Angular when actual Angular route
    let cancelled = false;
    (async () => {
      await customElements.whenDefined('usermgmt-app');   // the Angular listener exists from here on
      if (!cancelled && location.pathname.startsWith('/usermgmt'))
        window.dispatchEvent(new CustomEvent('angular-navigate', { detail: location.pathname + location.search }));
    })();
    return () => { cancelled = true; };
  }, [hidden]);

  return (
    <div style={{ display: hidden ? "none" : "block" }}>
      <usermgmt-app></usermgmt-app>
    </div>
  );
}